import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";

export default class VistaFormCambioContraseña extends Component {
  constructor(props) {
    super(props);
    this.newPasswordPut = this.newPasswordPut.bind(this);
    this.getToken = this.getToken.bind(this);
  }

  newPasswordPut(event) {
    event.preventDefault();
    let $this = $(this);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/perfil",
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        currentPassword: event.target["currentPassword"].value,
        newPassword: event.target["newPassword"].value,
        confirmPassword: event.target["confirmPassword"].value,
      },
    };

    // En caso de exito asigna los valores al componente de monja detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha modificado la contraseña correctamente", "success");

        $this[0].getToken(event.target["newPassword"].value);
      })
      .fail($this[0].props.ErrorHandling);
  }

  // Función para la llamada a getToken
  getToken(password) {
    let $this = $(this);
    let settings = {
      url: process.env.REACT_APP_API_URL + "/get-token",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        username: $this[0].props.perfil.email,
        password: password,
      },
    };

    $.ajax(settings).fail($this[0].props.ErrorHandling);
  }

  render() {
    return (
      <Form className=" p-4" onSubmit={this.newPasswordPut} autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              <p>
                {"La nueva contraseña debe contener mayúsculas, minúsculas, números y alguno de los siguientes caracteres:  "}
                <b>#?!@$%^&*-_</b>
              </p>
            </small>
          </Form.Row>
          <Form.Label>Contraseña Antigua</Form.Label>
          <Form.Control required autoComplete="nope" type="password" name="currentPassword" />
        </Form.Group>
        <Form.Group>
          <Form.Label>Contraseña Nueva</Form.Label>
          <Form.Control required autoComplete="nope" type="password" name="newPassword" pattern="(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$" />
        </Form.Group>
        <Form.Group>
          <Form.Label>Confirmar Contraseña</Form.Label>
          <Form.Control required autoComplete="nope" type="password" name="confirmPassword" pattern="(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$" />
        </Form.Group>
        <Form.Group>
          <Button type="submit" variant="outline-success" className="btn btn-block mt-5">
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
